module.exports = __webpack_public_path__ + "static/img/func-3.625e8ca8.png";